import React from 'react'

/**
 * QuoteBlock — a centered single-sentence typographic statement. Used for
 * cards that hold one weighted thought: Key takeaway, One change.
 *
 * Variants:
 *  - 'berry' (backward-facing — Key takeaway: "from this session")
 *  - 'olive' (forward-facing — One change: "next session ↗")
 *
 * Display serif, 18px, opsz 36; decorative open/close glyphs; mono caption
 * beneath. Hard cap 140 chars at the parent's authoring layer.
 *
 * Spec: claude_design/design-system/primitives.html §8.6
 */
export function QuoteBlock({
  variant = 'berry',
  text,
  caption,
  showQuotes = true,
  className = '',
  ...rest
}) {
  const classes = ['quoteblock', `quoteblock--${variant}`, className].filter(Boolean).join(' ')
  const showOpen = showQuotes && variant === 'berry'
  const showClose = showQuotes && variant === 'berry'
  return (
    <blockquote className={classes} {...rest}>
      {showOpen && <span className="quoteblock__open" aria-hidden="true">“</span>}
      <p className="quoteblock__text">{text}</p>
      {showClose && <span className="quoteblock__close" aria-hidden="true">”</span>}
      {caption && <footer className="quoteblock__caption">{caption}</footer>}
    </blockquote>
  )
}
